import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/ai-auditas/kaina/page.tsx");
